import type React from 'react'
import {useMemo} from 'react'
import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {Outlet} from '@github-ui/react-router'
import {useSearchBarEvents} from './hooks/use-search-bar-events'

export function App({children}: {children?: React.ReactNode}) {
  useSearchBarEvents()

  const metadata = useMemo(() => ({}), [])
  // Navigator supplies the matched route as children; Data Router renders nested routes through the Outlet.
  return (
    <AnalyticsProvider appName={'blackbird'} category={''} metadata={metadata}>
      {children ?? <Outlet />}
    </AnalyticsProvider>
  )
}
